<template>
	<div class="not_handle">
		<div v-if="!hasData">
			<loading :tip="tip"></loading>
		</div>
		<div v-else>
			<el-dialog :title="noteOrderInfo ? $t('other.a673') + noteOrderInfo.orderId : $t('other.a674')"
				:visible.sync="noteOrderDia" width="40%">
				<div>
					<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" :placeholder="$t('other.a675')"
						v-model="msgToStore"> </el-input>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="info" @click="noteOrderDia = false">{{ $t('other.a5') }}</el-button>
					<el-button v-if="noteOrderInfo" type="primary" @click="confirmNoteOrder()">{{ $t('other.a274')
					}}</el-button>
					<el-button v-if="!noteOrderInfo" type="primary" @click="massNoteOrder()">{{ $t('other.a274')
					}}</el-button>
				</span>
			</el-dialog>
			<el-dialog :title="$t('other.a946')" :visible.sync="printedvisabable" width="80%">
				<el-table border :data="printedUrl" height="400">
					<el-table-column :label="$t('other.a947')">
						<template slot-scope="scope">
							{{ scope.row.name }}
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a838')" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							{{ scope.row.shopName }}
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a595')" width="120">
						<template slot-scope="scope">
							{{ scope.row.platform }}
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a948')" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							{{ scope.row.createTime ? getTime(scope.row.createTime) : $t('other.a949') }}
						</template>
					</el-table-column>
					<el-table-column prop="address" width="280px" :label="$t('other.a33')">
						<template slot-scope="scope">
							<el-button style="width:110px;" size="mini" :type="!scope.row.hasPrined ? 'primary' : 'warning'"
								@click="gotoprint(scope.row)">{{ scope.row.hasPrined ? $t('other.a950') :
									$t('other.a951') }}</el-button>
							<el-button style="width:110px;" size="mini" type="primary" @click="printPicklist(scope.row)">{{
								$t('other.a952') }}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div style="text-align: right;margin-top:20px">
					<el-button type="primary" @click="printedvisabable = false">{{ $t('other.a5') }}</el-button>
					<el-button type="primary" @click="refleshPage()">{{ $t('other.a953') }}</el-button>
				</div>
			</el-dialog>

			<el-dialog :title="$t('other.a954')" :visible.sync="openReturnDia" width="40%">
				<el-table border :data="returnError" max-height="400">
					<el-table-column label="orderId" width="200">
						<template slot-scope="scope">
							{{ scope.row.orderId }}
						</template>
					</el-table-column>
					<el-table-column label="msg" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							{{ scope.row.msg }}
						</template>
					</el-table-column>

				</el-table>
				<div style="text-align: right;margin-top:20px">
					<el-button type="primary" @click="openReturnDia = false">{{ $t('other.a5') }}</el-button>
					<el-button type="primary" @click="openReturnDia = false">{{ $t('other.a955') }}</el-button>
				</div>
			</el-dialog>

			<el-dialog :title="$t('other.a956')" :visible.sync="orderDescInfo" width="50%">
				<div class="nonjb">
					<div class="pjhvh" v-if="timeOptions.shippedTime">
						<span>{{ timeOptions.shippedTime }} </span>
						<span style="margin-left:15px">{{ $t('other.a957') }}</span>
					</div>
					<div class="pjhvh" v-if="timeOptions.packageTime">
						<span>{{ timeOptions.packageTime }} </span>
						<span style="margin-left:15px">{{ $t('other.a958') }}</span>
					</div>


					<div class="pjhvh" v-if="timeOptions.checkTime">
						<span>{{ timeOptions.checkTime }} </span>
						<span style="margin-left:15px">{{ $t('other.a959') }}</span>
					</div>

					<div class="pjhvh" v-if="timeOptions.printTime">
						<span>{{ timeOptions.printTime }} </span>
						<span style="margin-left:15px">{{ $t('other.a960') }}</span>
					</div>

					<div class="pjhvh" v-if="timeOptions.pickListTime">
						<span>{{ timeOptions.pickListTime }} </span>
						<span style="margin-left:15px">{{ $t('other.a961') }}</span>
					</div>

					<div class="pjhvh" v-if="timeOptions.auditTime">
						<span>{{ timeOptions.auditTime }} </span>
						<span style="margin-left:15px">{{ $t('other.a962') }} </span>
					</div>
				</div>
				<div style="text-align: right;margin-top:20px">
					<el-button size="medium" type="primary" @click="orderDescInfo = false">{{ $t('other.a5') }}</el-button>
				</div>
			</el-dialog>

			<!-- 同步商品链接 -->
			<el-dialog :title="$t('other.a3372')" :visible.sync="synchronizeProductsShow" key="itemKey" width="30%">
				<div>
					<div class="ipt" style="display: flex;align-items: center;">
						<div class="iptText" style="width: 60px;">店铺：</div>
						<el-select v-model="synchronizeProductsCheck" placeholder="请选择">
							<el-option v-for="item in synchronizeProductsArr" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="ipt" style="display: flex;align-items: center;flex-wrap: wrap;margin-top: 10px;"
						v-if="synchronizeProductsStatus == 2">
						<div class="iptText" style="margin-bottom: 10px;">请输入需要同步平台的SKCID列表：</div>
						<el-input type="textarea" :rows="4" placeholder="请输入需要同步平台的SKCID列表"
							v-model="synchronizeProductsSKC">
						</el-input>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="synchronizeProductsShow = false">{{ $t('other.a5') }}</el-button>
					<el-button type="primary" @click="synchronizeProducts()">{{ $t('other.a38') }}</el-button>
				</span>
			</el-dialog>


			<div v-show="isNotify" class="notify-boxw">
				<div style="font-weight: bold; margin-bottom: 10px;">{{ $t('other.a963') }}</div>
				<span style="margin-right: 20px;">{{ $t('other.a964') }}{{ multipleSelection.length }}{{ $t('other.a965')
				}}{{ successTotal }}</span>
				<i class="el-icon-loading"></i>
			</div>

			<!-- 旗帜弹窗 -->
			<flag-plugin :isFlage.sync="isFlage" @setFlags="setFlags"></flag-plugin>
			<div class="title">{{ $t('storePending').desc }}</div>
			<div class="step">
				<el-steps finish-status="success">
					<el-step :title="storePending.fisrtStep" :description="storePending.firstDesc">{{
						$t('storePending').MassPrintShipingLabel }}</el-step>
					<el-step :title="storePending.secondStep" :description="storePending.secondDesc"></el-step>
					<el-step :title="storePending.threeStep" :description="storePending.threeDesc"></el-step>
					<el-step :title="storePending.fourStep" :description="storePending.fourDesc"></el-step>
				</el-steps>
			</div>

			<div class="btn_box">
				<div class="btn_outer" v-for="(item, index) in btnlist" :key="index">
					<div style="display: flex;justify-content: flex-start;">
						<!-- 类型 -->
						<div class="btn_desc">{{ item.desc }}:</div>
						<div>
							<!-- 选项 -->
							<span :class="{ 'btn_item': true, 'btn_item_active': activeIndex[index] == indexTwo }"
								v-for="(children, indexTwo) in item.option" :key="indexTwo"
								@click="handleBtn(children.key, index, indexTwo)">
								<span v-if="index !== 6">{{ conversion(children.key, index) }}({{ children.value.length
								}})</span>

								<span
									v-if="index == 6 && (children.key == 'all' || children.key == 0 || children.key == 99999)">{{
										conversion(children.key, index) }}<span v-if="index == 6 && (children.key == 'all')">({{
		children.value.length }})</span></span>


								<el-tooltip style="font-size: 16px;" effect="light"
									v-if="index == 6 && indexTwo > 0 && children.key !== 'all'"
									:content="getDesc(children.key)" placement="top">

									<span v-if="index == 6 && indexTwo > 0 && children.key !== 'all'"
										:style="showFlageStyle(children.key)"></span>

								</el-tooltip>

								<span v-if="index == 6 && indexTwo > 0 && children.key !== 'all'">({{ children.value.length
								}})</span>

							</span>
						</div>

					</div>
				</div>
			</div>
			<div class="search_wraper">
				<div class="search_item">
					<span class="item_desc">{{ $t('other.a966') }}：</span>
					<el-input v-model="searchOrderId" :placeholder="$t('other.a26')" clearable></el-input>
				</div>
				<div class="search_item">
					<span class="item_desc">{{ $t('other.a967') }}：</span>
					<el-input v-model="searchName" :placeholder="$t('other.a968')" clearable></el-input>
				</div>
				<div class="search_item">
					<span>{{ $t('other.a64') }}：</span>
					<el-select v-model="sortType" :placeholder="$t('orderPrint.Order_sorting')" @change="choiceshopId()">
						<el-option :label="$t('orderPrint.Ordertimeorder01')" value="1">{{ $t('orderPrint.Ordertimeorder01')
						}}</el-option>
						<el-option :label="$t('orderPrint.Ordertimeorder02')" value="2">{{ $t('orderPrint.Ordertimeorder02')
						}}</el-option>
						<el-option :label="$t('orderPrint.Sortbyquantity01')" value="3">{{ $t('orderPrint.Sortbyquantity01')
						}}</el-option>
						<el-option :label="$t('orderPrint.Sortbyquantity02')" value="4">{{ $t('orderPrint.Sortbyquantity02')
						}}</el-option>
						<el-option :label="$t('orderPrint.Sort_by_number_ofsku01')" value="5">{{
							$t('orderPrint.Sort_by_number_ofsku01') }}</el-option>
						<el-option :label="$t('orderPrint.Sort_by_number_ofsku02')" value="6">{{
							$t('orderPrint.Sort_by_number_ofsku02') }}</el-option>
						<el-option :label="$t('other.a969')" value="7">{{ $t('other.a969') }}</el-option>
						<el-option :label="$t('other.a970')" value="8">{{ $t('other.a970') }}</el-option>
					</el-select>
				</div>
			</div>
			<div class="operation_area">

				<div class="opeartion_btn">
					<el-dropdown class="checkallbox">
						<span class="el-dropdown-link">
							<el-button type="primary">
								{{ $t('storePending').massArrangeShipment }}<i
									class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="startReadyOrders(0)">
								<span class="checkallbox">{{ $t('storePending').drop_off }}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="startReadyOrders(1)">
								<span class="checkallbox">{{ $t('storePending').pick_up }}</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>

				<div class="opeartion_btn">

					<el-dropdown class="checkallbox">
						<span class="el-dropdown-link">
							<el-button type="primary">
								{{ $t('storePending').massprint }}<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="mergerPrintPicklist()">
								<span class="checkallbox">{{ $t('storePending').PrintPacklist }}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="goStockList()">
								<span class="checkallbox">{{ $t('storePending').PrintPicklist }}</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="opeartion_btn">
					<el-dropdown class="checkallbox">
						<span class="el-dropdown-link">
							<el-button type="primary">
								{{ $t('storePending').MassPrintShipingLabel }}<i
									class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="printDefaultOrder()">
								<span class="checkallbox">{{ $t('storePending').PrintShipingLabel }}</span>
							</el-dropdown-item>
							<el-dropdown-item v-show="showFastBtn" @click.native="printFastOrder()">
								<span class="checkallbox">{{ $t('storePending').ShipingLabel_Packlist }}</span>
							</el-dropdown-item>
							<!-- <el-dropdown-item v-show="showFastBtn" @click.native="printFastOrderSH()">
								<span class="checkallbox" >{{$t('other.a1032')}}(Shopee)</span>
							</el-dropdown-item>
							<el-dropdown-item v-show="userId==='kevin985517@gmail.com'" @click.native="printFastOrderLA()">
								<span class="checkallbox" >{{$t('other.a1032')}}(LAZADA)</span>
							</el-dropdown-item>
							<el-dropdown-item v-show="showFastBtn" @click.native="showinformation">
								<span class="checkallbox" >{{$t('other.a1034')}}</span>
							</el-dropdown-item> -->
						</el-dropdown-menu>
					</el-dropdown>
					<el-dialog :title="$t('other.a971')" :visible.sync="information" width="40%"
						:before-close="handleClose">
						<el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
							<el-form-item :label="$t('other.a972')">
								<el-input v-model="formLabelAlign.name"></el-input>
							</el-form-item>
							<el-form-item :label="$t('other.a973')">
								<el-input v-model="formLabelAlign.phone"></el-input>
							</el-form-item>
							<el-form-item :label="$t('other.a974')">
								<el-input v-model="formLabelAlign.address" type="textarea" :rows="5"></el-input>
							</el-form-item>
						</el-form>
						<span slot="footer" class="dialog-footer">
							<el-button @click="information = false">{{ $t('other.a106') }}</el-button>
							<el-button type="primary" @click="chckeformation">{{ $t('other.a279') }}</el-button>
						</span>
					</el-dialog>
				</div>
				<div class="opeartion_btn">
					<el-dropdown class="checkallbox">
						<span class="el-dropdown-link">
							<el-button type="primary">
								{{ $t('other.a975') }}<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="isFlage = true">
								<span class="checkallbox">{{ $t('other.a390') }}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="noteOrderDia = true, noteOrderInfo = null">
								<span class="checkallbox">{{ $t('other.a700') }}</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<!-- <el-button type="primary" @click="isFlage=true">{{$t('other.a390')}}</el-button> -->
				</div>

				<!-- <div class="opeartion_btn"><el-button type="primary" @click="returnOrder()">{{
					$t('storePending').ReturnBacktoUser }}</el-button></div> -->
				<div class="opeartion_btn">
					<el-button type="primary" @click="synchronizeOrderProcessingProgress()">同步订单处理进度</el-button>
					<!-- <el-dropdown class="checkallbox">
						<span class="el-dropdown-link">
							<el-button type="primary">
								{{ $t('storePending').SynchronizeOrder }}<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="Synchronize(0)">
								<span class="checkallbox">{{ $t('pendingorder.last_3_days') }}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="Synchronize(1)">
								<span class="checkallbox">{{ $t('pendingorder.last_7_days') }}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="Synchronize(2)">
								<span class="checkallbox">{{ $t('pendingorder.last_1_month') }}</span>
							</el-dropdown-item>
							<el-dropdown-item @click.native="reloadorder = true">
								<span class="checkallbox">{{ $t('other.a976') }}</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown> -->
				</div>
				<div class="opeartion_btn">
					<!-- <el-button type="primary" @click="synchronizeProducts()">{{ $t('other.a3372')
				}}</el-button> -->
					<el-dropdown>
						<el-button style="margin-left：10px;" type="primary">
							{{
								$t('other.a3372')
							}}
							<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="synchronizeProductsOpen(1)">同步单店铺</el-dropdown-item>
							<el-dropdown-item @click.native="synchronizeProductsOpen(2)">同步指定SKC</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="opeartion_btn"><el-button type="primary" @click="extportOrderInfo()">{{ $t('other.a977')
				}}</el-button></div>

			</div>

			<div class="checkallbox" @click="toggleSelection">{{ chooseAll ? $t('orderPrint.Unselect_current_page') :
				$t('orderPrint.Select_current_page') }}({{ multipleSelection.length }})</div>
			<div class="order_box">
				<el-table ref="multipleTable" :data="listData" tooltip-effect="dark" border style="width: 100%"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55">
					</el-table-column>

					<el-table-column label="Order ID" width="250">
						<template slot-scope="scope">
							<div>
								<el-tooltip v-show="scope.row.amend" effect="light" :content="$t('other.a978')"
									placement="bottom">
									<i class="iconfont icon-sign"></i>
								</el-tooltip>
								<span>{{ $t('other.a52') }}：{{ scope.row.orderId }}</span>
							</div>
							<div v-if="scope.row.orderPdf">{{ kvjmfh(scope.row.orderPdf) }}</div>
							<div>{{ $t('other.a55') }}：{{ statusOrder[scope.row.orderStatus] }}</div>
							<div>{{ $t('other.a838') }}：{{ scope.row.shopName }}</div>
							<div class="ordersn-box tooldesc" @click="editMark(scope.row)">
								<i class="el-icon-edit" v-show="!scope.row.flagId && userPos == 'SELLER'">
									{{ $t('other.a979') }}</i>
								<div style="width: 100%;text-overflow: ellipsis;" v-show="scope.row.flagId > 0"
									v-for="(item, index) in showFlage(scope.row.flagId) " :key="index">
									<span :style="item.style"></span>
									<span style="width: 80px;margin-left: 5px;text-overflow: ellipsis;">{{ item.desc
									}}</span>
								</div>
							</div>
							<div v-if="scope.row.msgToStore" style="color:red;margin-top:15px;">
								{{ $t('other.a499') }}：{{ scope.row.msgToStore }}</div>
						</template>
					</el-table-column>
					<el-table-column label="Order Time" width="220">
						<template slot-scope="scope">
							<div class="order_time">{{ $t('other.a588') }}：{{ scope.row.createTime }}</div>
							<div class="order_time" v-if="!scope.row.cod">{{ $t('other.a589') }}：{{ scope.row.payTime }}
							</div>
							<div class="order_time" v-if="scope.row.cod">{{ $t('other.a589') }}：{{ $t('other.a980') }}</div>
							<div class="order_time">{{ $t("other.a898") }}：{{ scope.row.auditTime }}</div>
							<div class="order_time">{{ $t('other.a590') }}({{ scope.row.printNum }})：
								<span v-if="scope.row.printTime">{{ scope.row.printTime }}</span>
								<span v-if="scope.row.printTime == null">{{ $t('other.a949') }}</span>
							</div>
							<div class="order_time">{{ $t('other.a981') }}：
								<span v-if="scope.row.checkTime">{{ getTime(scope.row.checkTime) }}</span>
								<span v-if="scope.row.checkTime == null">{{ $t('other.a982') }}</span>
							</div>
							<div class="order_time">{{ $t('other.a591') }}：
								<span v-if="scope.row.packagedTime">{{ scope.row.packagedTime }}</span>
								<span v-if="scope.row.packagedTime == null">{{ $t('other.a983') }}</span>
							</div>
						</template>
					</el-table-column>

					<el-table-column label="Product(s)">
						<template slot-scope="scope">
							<span v-for="(item, index) in scope.row.items" :key="index">
								<el-tooltip placement="right">
									<span slot="content">
										<div style="display: flex; color: #FFFFFF;align-items: center;">
											<span
												style="display: inline-block;width: 80px;height: 80px;margin-right: 20px;">
												<img style="width:100%"
													:src="item.attributeImage ? item.attributeImage : item.image" />
											</span>
											<span>

												<div style="padding:2px 0px;font-size:15px">Name：{{ item.itemName }}</div>
												<div v-if="item.storeItem !== null">
													<div style="padding:5px 0px;font-size:15px">
														cusCode：{{ item.storeItem.cusCode }}（{{ item.storeItem.component ?
															$t('other.a251') : $t('other.a252') }}）</div>
													<div style="padding:5px 0px;font-size:15px">
														P_SKU：{{ item.storeItem.itemSku ? item.storeItem.itemSku :
															$t('other.a260') }}</div>
													<div style="margin-top: 5px;font-size:15px"
														v-if="item.storeItem.children !== null && !item.storeItem.component">
														<div v-for="(childre, indexTBB) in item.storeItem.children"
															:key="indexTBB">
															{{ $t('other.a920') }}({{ childre.cusCode }})：{{ childre.skuName
															}}
															{{ $t('other.a633') }}：{{ childre.rate *
																item.variationQuantityPurchased }}
														</div>
													</div>
													<div style="margin-top: 5px;font-size:15px"
														v-if="item.storeItem.children == null">
														<div>
															W_SKU：{{ item.storeItem.skuName }}
															{{ $t('other.a633') }}：{{ item.variationQuantityPurchased }}
														</div>
													</div>
													<div v-if="item.storeItem.additions !== null"
														style="padding:5px 0px;font-size:15px">
														<div style="margin-top: 5px;font-size:15px;color:red"
															v-for="(gift, giftIndex) in item.storeItem.additions"
															:key="giftIndex">
															{{ $t('other.a497') }}：{{ gift.skuName }}（{{ gift.cusCode }}）
															{{ $t('other.a567') }}：{{ gift.rate *
																item.variationQuantityPurchased }}
														</div>

													</div>
												</div>
												<div style="margin-top: 5px;font-size:15px">
													{{ $t('other.a250') }}{{ item.storeItem ? item.storeItem.storeNum :
														'' }}，{{ $t('other.a1038') }}：{{ item.storeItem ?
		item.storeItem.unShipped :
		'' }} ，{{ $t('other.a1037') }}：{{ item.storeItem ? item.storeItem.stock
		:
		'' }}</div>
											</span>
										</div>
									</span>
									<span>
										<span class="pic_wrapper">
											<img style="width: 100%;"
												:src="item.attributeImage ? item.attributeImage : item.image" />
											<span class="pic-wrapper-quantity">{{ item.variationQuantityPurchased }}</span>
											<!-- <span v-show="item.storeItem ? item.storeItem.stock < 0 : false" class="pic-wrapper-desc">库存不足</span> -->
										</span>

									</span>
								</el-tooltip>


							</span>
						</template>
					</el-table-column>
					<el-table-column label="Logistics">
						<template slot-scope="scope">
							<div class="ordersn-box">{{ $t('other.a984') }}：{{ scope.row.logistics }}</div>
							<div class="ordersn-box">{{ $t('other.a86') }}<span v-if="scope.row.trackingNo">{{
								scope.row.trackingNo }}</span><span v-else>{{ $t('other.a985') }}</span> </div>


						</template>
					</el-table-column>

					<el-table-column label="Status">
						<template slot-scope="scope">

							<div style="margin-bottom:10px">
								<span style="font-size:12px;font-weight:bold;color:red">{{
									scope.row.timeList[scope.row.timeList.length - 1] }}</span>
							</div>
							<div style="margin-bottom:10px">
								<el-button style="min-width:110px" size="mini" type="primary"
									@click="getDetailInfo(scope.row)">{{ $t('other.a986') }}</el-button>
							</div>
							<div style="margin-bottom:10px">
								<el-button style="min-width:110px" size="mini" type="primary"
									@click="noteOrderDia = true, noteOrderInfo = scope.row">{{ $t('other.a714')
									}}</el-button>
							</div>
							<div style="color: red;">
								<el-button style="min-width:110px" v-if="!scope.row.other" size="mini" type="primary"
									@click="sellerRemind(scope.row, 0)">{{ $t('other.a987') }}</el-button>
								<el-button style="min-width:110px" v-if="scope.row.other" size="mini" type="danger"
									@click="sellerRemind(scope.row, 1)">{{ $t('other.a988') }}</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="Pager">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[15, 30, 50, 100, 200]" :page-size="offset"
					layout="total, sizes, prev, pager, next, jumper" :total="totalList">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>



import Condition from '../../../components/condition'
import newOrdersApi from '../../../api/moudles/newOrders'
import loading from '../../../components/loadingTip'
import utils from '../../../utils/utils'
import config from '../config.js'
import { ORDER_STATUS } from '../../../config/config'
import printApi from '../../../api/moudles/print.js'
import FlagPlugin from '../../../components/flag.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
import api from '../../../api/api'
import orders from '../../../api/moudles/order'
export default {
	data() {
		return {
			essential: [],
			labelPosition: 'right',
			formLabelAlign: {
				name: '',
				phone: '',
				address: ''
			},
			information: false,
			getDataParams: {},
			userPos: JSON.parse(localStorage.getItem('userInfo')).userPos,
			allstoreIds: JSON.parse(localStorage.getItem('userInfo')).storeIds,
			allshopIds: JSON.parse(localStorage.getItem('userInfo')).shopIds,
			orderlist: [],
			setFlagsList: [],
			multipleSelection: [],
			mapList: [],
			btnlist: [],
			totalList: 0,
			returnError: [],
			openReturnDia: false,
			activeIndex: [],
			target: 'all',
			offset: 50,
			currentPage: 1,
			showFastBtn: true,
			sortType: '8',
			page: 1,
			searchOrderId: '',
			searchName: '',
			printedvisabable: false,
			printedUrl: [],
			itemTargetList: [],
			isFlage: false,
			flashPage: config.flagList,
			activeBtnIndex: ['all', 0, 0],
			isNotify: false,
			successTotal: 0,
			chooseAll: false,
			tip: this.$t('other.a989'),
			hasData: false,
			desc: '85241',
			orderDescInfo: false,
			timeOptions: {},
			statusOrder: {},
			noteOrderDia: false,
			noteOrderInfo: {},
			msgToStore: null,

			synchronizeProductsStatus: 1,
			synchronizeProductsShow: false,
			synchronizeProductsArr: [],
			synchronizeProductsCheck: '',
			synchronizeProductsSKC: '',

		}
	},
	components: {
		FlagPlugin,
		loading
	},
	computed: {
		...mapState({
			userId: state => state.shopaccess.userInfo.userId,


		}),

		storePending() {
			return this.$t('storePending')
		},



		listData() {

			let ttp = this.activeIndex[10] == 0 ? 'all' : this.activeIndex[10] == 1 ? true : false
			let list = []
			if (this.mapList.length) {
				list = this.mapList[10].get(ttp)
			}

			this.totalList = list.length
			let list2 = []
			let arr2 = []


			//先按订单号查找
			if (this.searchOrderId.length > 0) {
				//对订单号筛选，筛选完之后的订单数据就在list3
				list.forEach((order) => {
					if (this.searchOrderId.length > 0) {
						let value = JSON.parse(JSON.stringify(this.searchOrderId)).trim()
						if (value.includes(' ')) {
							value = value.split(' ')
							if (value.includes(order.orderId)) {
								list2.push(order)
							}
						} else {
							if (order.orderId == this.searchOrderId.trim()) {
								list2.push(order)
							}
						}
					} else {
						list2 = list;
					}
				})


			} else if (this.searchName.length > 0) {
				//订单的包含查询
				list.forEach((order) => {
					order.items.forEach(k => {
						if (this.searchName.length > 0) {
							if ((k.storeItem && k.storeItem.cusCode) == this.searchName.trim() || order.printTime == this.searchName.trim() || order.auditTime == this.searchName.trim() || order.auditTime == this.searchName.trim() || this.fuzzyMatch(k.itemName, this.searchName.trim()) || this.fuzzyMatch(k.variationSku, this.searchName.trim()) || this.fuzzyMatch(k.storeItem ? k.storeItem.itemSku : null, this.searchName.trim()) || this.fuzzyMatch(k.storeItem ? k.storeItem.skuName : null, this.searchName.trim()) || this.fuzzyMatch(k.itemKey, this.searchName.trim())) {

								arr2.push(order)

							}
						} else {
							arr2 = list;
						}
					})
				})

				//数组去重
				let obj = {}
				list2 = arr2.reduce((cur, next) => {
					obj[next.orderId] ? '' : obj[next.orderId] = true && cur.push(next)
					return cur
				}, [])
				console.log('list2', list2)


			} else {
				list2 = list

			}

			console.log('list2', list2)

			list2.sort((a, b) => {
				if (this.sortType == 1) {
					return new Date(a.createTime) - new Date(b.createTime)
				}
				if (this.sortType == 2) {
					return new Date(b.createTime) - new Date(a.createTime)
				}
				if (this.sortType == 3) {
					if (b.itemNum == 1 && a.itemNum == 1)
						if (a.items[0].itemId == b.items[0].itemId) {
							if (a.items[0].variationId == b.items[0].variationId) {
								return b.itemAmount - a.itemAmount
							} else {
								return a.items[0].variationId - b.items[0].variationId
							}
						} else {
							return a.items[0].itemId - b.items[0].itemId
						}
					return b.itemAmount - a.itemAmount

				}
				if (this.sortType == 4) {
					if (b.itemNum == 1 && a.itemNum == 1)
						if (a.items[0].itemId == b.items[0].itemId) {
							if (a.items[0].variationId == b.items[0].variationId) {
								return a.itemAmount - b.itemAmount
							} else {
								return a.items[0].variationId - b.items[0].variationId
							}
						}
					return a.itemAmount - b.itemAmount
				}
				if (this.sortType == 5) {
					if (b.itemNum == a.itemNum) {
						if (a.items[0].itemId == b.items[0].itemId) {
							if (a.items[0].variationId == b.items[0].variationId) {
								return a.itemAmount - b.itemAmount
							} else {
								return a.items[0].variationId - b.items[0].variationId
							}
						} else {
							return a.items[0].itemId - b.items[0].itemId
						}
					}
					return b.itemNum - a.itemNum
				}
				if (this.sortType == 6) {
					if (b.itemNum == a.itemNum) {
						if (a.items[0].itemId == b.items[0].itemId) {
							if (a.items[0].variationId == b.items[0].variationId) {
								return a.itemAmount - b.itemAmount
							} else {
								return a.items[0].variationId - b.items[0].variationId
							}
						} else {
							return a.items[0].itemId - b.items[0].itemId
						}
					}
					return a.itemNum - b.itemNum
				}

				if (this.sortType == 7) {
					return new Date(a.auditTime) - new Date(b.auditTime)

				}

				if (this.sortType == 8) {
					return new Date(b.auditTime) - new Date(a.auditTime)
				}
				return a.itemNum - b.itemNum
			})

			this.totalList = list2.length
			// 订单分页
			console.log((this.page - 1) * this.offset, (this.page) * this.offset)
			let list3 = list2.slice((this.page - 1) * this.offset, this.page * this.offset)
			console.log('list3', list3)

			return list3
			console.log(ttp)

		}



	},
	inject: ['reload'],
	watch: {
		noteOrderDia() {
			if (!this.noteOrderDia) {
				this.msgToStore = null
			}
		},
	},
	created() {
		this.statusOrder = ORDER_STATUS
		this.init()
		this.getNotHandlePages()
		this.getUserFlags({ userId: this.userId })

	},
	mounted() {
		// this.getUserAddress();
	},
	methods: {
		...mapActions('lazadaorders', [
			'getLazadaOrderByuserid'
		]),

		...mapActions('order', [
			'getUnprocessOrder', //获取所有商店待处理订单
			'auditOrder',
			'getPrintOrder', //打印订单
			'getOrdersBytrickNo',
			'getInitOrderBypickup',
			'getInitOrderBydropoff',
			'updatShopAllOrders',
			'getSpeciesOrder',
			'getGoodsOrder',
			'getLogistics',
			'addPrintTimes',
			'getPrintSheetHistory',
			'getPrintTogether',
			'storeReceived',
			'regeneratePDF',
			'getGoodsTypeByStore'

		]),
		...mapMutations('order', [
			'SET_ORDER_FINISH',
		]),


		...mapActions('print', [
			'getUserFlags',
		]),
		...mapActions('mygoods', [
			'tongBuShopee',
		]),



		massNoteOrder() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				this.noteOrderDia = false
				return
			}
			let list = JSON.parse(JSON.stringify(this.multipleSelection))
			let params = list.map(p => {
				return {
					msgToStore: this.msgToStore,
					orderId: p.orderId,
					shopId: p.shopId,
					userId: this.userId
				}
			})

			let list2 = []
			params.forEach(i => {
				list2.push(this.setOrderNoteToStore(i))
			})


			Promise.all(list2).then((res) => {
				console.log('res', res)
				let flag = false
				res.forEach(i => {
					if (i !== 'success') {
						flag = true
					}
				})
				this.updateOrderInfo()
				this.noteOrderDia = false
				if (!flag) {
					this.multipleSelection.forEach(p => {
						p.checked = false
						p.msgToStore = this.msgToStore
					})
					this.$message.success(this.$t('other.a990'))
				} else {
					this.$message.warning(this.$t('other.a991'))
				}

			})
		},


		setOrderNoteToStore(params) {
			return new Promise((resolve, reject) => {
				newOrdersApi
					.updateMsgToStore(params)
					.then(res => {
						if (res.code === 200) {
							resolve('success')

						} else {
							reject('fail data')
							this.$message.warning(res.msg)
						}
					})
			})
		},



		confirmNoteOrder() {
			console.log(this.noteOrderInfo)
			if (!this.msgToStore) {
				this.msgToStore = null
			}

			newOrdersApi
				.updateMsgToStore({
					msgToStore: this.msgToStore,
					orderId: this.noteOrderInfo.orderId,
					shopId: this.noteOrderInfo.shopId,
					userId: this.userId
				})
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						this.noteOrderInfo.msgToStore = this.msgToStore
						this.noteOrderDia = false
						this.updateOrderInfo()
						this.$message.success(this.$t('other.a719'))

					} else {
						this.$message.warning(res.msg)
					}
				})


		},
		getUserAddress() {
			let params = {
				// cacheData:JSON.stringify(this.formLabelAlign),
				cacheKey: this.userId + '_' + 'Shipper_Address',
				userId: this.userId
			}
			api
				.getUserCache(params)
				.then(res => {
					if (res.code === 200) {

						if (res.data) {
							this.formLabelAlign = JSON.parse(res.data.cacheData)
						} else {
							this.$message.warning(this.$t('other.a992'))

							setTimeout(() => {
								this.information = true;
							}, 1000);
						}

					} else {
						this.$message.warning(res.msg)
					}
				})
		},//获取发货详细信息
		showinformation() {
			this.information = true;

		},
		chckeformation() {
			let params = {
				cacheData: JSON.stringify(this.formLabelAlign),
				cacheKey: this.userId + '_' + 'Shipper_Address',
				userId: this.userId
			}

			api
				.setUserCache(params)
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						this.$message.success(this.$t('other.a993'))
						this.getUserAddress();
						this.information = false;
					} else {
						this.$message.warning(res.msg)
					}
				})

			console.log(params)
			// this.essential.push(this.formLabelAlign)
			// console.log(JSON.stringify(this.formLabelAlign));
			// localStorage.setItem('userAddress',JSON.stringify(this.formLabelAlign));
			// this.information = false;

			// let params={
			// 	cacheData:JSON.stringify(this.formLabelAlign),
			// 	cacheKey:this.userId+'address',
			// 	userId:this.userId
			// }
			// api
			// .getUserCache(params)
			// .then(res => {
			// if(res.code === 200 ){



			// }else{
			// this.$message.warning(res.msg)
			// }
			// })
		},
		handleClose() {
			this.information = false;
		},
		sellerRemind(item, num) {
			if (num == 1) {
				this.$message.warning(this.$t('other.a994'))
				return
			}
			if (num == 0) {
				console.log(item)

				let time1 = new Date(item.auditTime).getTime() //typ
				let time2 = new Date(utils.getCurrnetTime(new Date())).getTime()
				// let time2=new Date('2021-07-09 9:08:00').getTime() //typ
				let ttp = (time2 - time1)
				let ccp = 60 * 60 * 1000
				console.log(ttp / ccp)
				//审核未超过24小时
				if ((ttp / ccp) < 24) {
					this.$confirm(this.$t('other.a995'), this.$t("other.a142"), {
						confirmButtonText: this.$t('other.a996'),
						cancelButtonText: this.$t('other.a146'),
						type: 'error'
					}).then(() => { })
					return
				}

				this.$confirm(this.$t('other.a997'), this.$t('other.a998'), {
					confirmButtonText: this.$t('other.a235'),
					cancelButtonText: this.$t('other.a146'),
					type: 'warning'
				}).then(() => {

					newOrdersApi
						.sellerRemind({
							userId: this.userId,
							shopId: item.shopId,
							storeId: item.storeId,
							orderId: item.orderId
						})
						.then(res => {
							if (res.code === 200) {
								console.log('desc', res.data)
								this.$message.success(this.$t('other.a999'))
							} else {
								this.$message.warning(res.msg)
							}
						})
				})
			}

		},


		getDetailInfo(item) {
			console.log(item)
			newOrdersApi
				.getOrderLogisticsInfo({ orderId: item.orderId })
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						this.timeOptions.auditTime = res.data.auditTime ? utils.renderTime(res.data.auditTime) : null
						this.timeOptions.pickListTime = res.data.pickListTime ? utils.renderTime(res.data.pickListTime) : null
						this.timeOptions.checkTime = item.checkTime ? item.checkTime : null
						this.timeOptions.printTime = res.data.printTime ? utils.renderTime(res.data.printTime) : null
						this.timeOptions.packageTime = res.data.packageTime ? utils.renderTime(res.data.packageTime) : null
						this.timeOptions.shippedTime = res.data.shippedTime ? utils.renderTime(res.data.shippedTime) : null





						this.orderDescInfo = true
					} else {
						this.$message.warning(res.msg)
					}
				})
		},

		refleshPage() {
			this.printedvisabable = false
			this.init()
			this.getNotHandlePages()
		},

		fuzzyMatch(str, key) {
			str == null ? '' : str
			if (typeof (str) == Number) {
				return str == key
			}

			if (str) {
				str = str.toUpperCase()
				key = key.toUpperCase()
				let ttp = false
				if (str.indexOf(key) != -1 || str == key) {
					ttp = true
				}
				return ttp


			} else {
				return false;
			}
		},

		extportOrderInfo() {
			let arr = []
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}
			console.log(this.multipleSelection)
			this.multipleSelection.forEach(p => {
				p.items.forEach((k, index) => {
					k.totalSku = ''
					k.totalQty = 0
					let num = index + 1
					if (k.storeItem && k.storeItem.component) {//单品
						k.totalSku = 'sku1' + ':' + k.storeItem.skuName + ' */Qty:' + k.variationQuantityPurchased
						k.totalQty = k.variationQuantityPurchased
					} else {//套餐
						if (k.storeItem && k.storeItem.children) {
							k.storeItem.children.forEach((j, ttb) => {
								let vdf = ttb + 1
								k.totalSku += 'sku' + vdf + '(' + j.cusCode + ')' + ':' + j.skuName + ' */Qty:' + k.variationQuantityPurchased * j.rate
								k.totalQty += j.rate * k.variationQuantityPurchased
							})
						}
					}
					arr.push({
						'订单号': p.orderId,
						'运单号': p.trackingNo,
						'收货人': p.address.name,
						'电话号码': p.address.phone,
						'详细地址': p.address.state + '/' + p.address.city + '/' + p.address.fullAddress,
						'产品名称': k.itemName,
						'单品或套餐': k.storeItem ? k.storeItem.component ? this.$t('other.a251') + k.storeItem.cusCode : this.$t('other.a252') + k.storeItem.cusCode : this.$t('other.a568'),
						'sku详情': k.totalSku,
						'sku数量': k.storeItem ? k.storeItem.component ? 1 : k.storeItem.children.length : this.$t('other.a568'),
						'购买总数': k.totalQty,
						'实收': k.price,
						'配送方式': p.logistics,
						'下单时间': utils.renderTime(p.createTime),
						'推送时间': p.auditTime,
						'打印时间': p.printTime,
						'出库时间': p.packagedTime,
					})
				})
			})

			let list = ['订单号', '运单号', '收货人', '电话号码', '详细地址', '产品名称', '单品或套餐', 'sku详情', 'sku数量', '购买总数', '实收', '配送方式', '下单时间', '推送时间', '打印时间', '出库时间']
			console.log('arr', arr)
			utils.exPortEXml(arr, list, list)

			this.allOrderList.forEach(item => {
				item.checked = false
			})
		},

		returnOrder() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}

			this.$confirm(this.$t('other.a1000') + this.multipleSelection.length + this.$t('other.a1001'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a145'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			}).then(() => {

				let list = this.multipleSelection.map(p => {
					return {
						orderId: p.orderId,
						shopId: p.shopId,
						storeId: p.storeId,
						userId: this.userId
					}
				})
				newOrdersApi
					.cancelAuditedOrders(list)
					.then(res => {
						if (res.code === 200) {
							if (res.data.errors.length > 0) {
								this.returnError = res.data.errors
								this.openReturnDia = true
							} else {
								this.$message.success(this.$t('other.a1002'))
								setTimeout(() => {
									let list = JSON.parse(JSON.stringify(this.mapList[0].get('all')))
									this.multipleSelection.forEach(p => {
										let num = list.findIndex(i => i.orderId === p.orderId)
										list.splice(num, 1)
									})
									console.log('list', list)
									this.orderClassification(list, -1)
									this.handleBtn(this.activeBtnIndex[0], this.activeBtnIndex[1], this.activeBtnIndex[2])
								}, 1000)

							}
						} else {
							this.$message.warning(res.msg)
						}
					})

			})
		},

		getDesc(id) {


			let ttp = this.flashPage.filter(p => p.flagId == id)

			if (ttp.length) {
				return ttp[0].desc
			} else {
				return this.$t("other.a354")
			}



		},

		editMark(item) {
			if (this.userPos == 'SELLER') {
				console.log(item)
				this.isFlage = true
				this.multipleSelection = [item]
			}


		},
		toggleSelection() {
			this.chooseAll = !this.chooseAll
			let rows = this.listData
			if (this.chooseAll) {
				this.$refs.multipleTable.clearSelection();
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row)
				})
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},

		showFlage(id) {
			let arr = []
			if (this.flashPage.length > 0) {
				this.flashPage.forEach(p => {
					if (p.flagId === id) {
						p.style.width = '20px'
						p.style.height = '20px'
						arr.push(p)
					}
				})
				return arr
			}
		},

		synchronizeProductsOpen(index) {
			this.synchronizeProductsStatus = index;
			this.synchronizeProductsArr = utils.getAllshop();
			if(this.synchronizeProductsArr.length>0){
				this.synchronizeProductsArr.shift();
			}
			this.synchronizeProductsSKC = '';
			this.synchronizeProductsCheck = this.synchronizeProductsArr.length > 0 ? this.synchronizeProductsArr[0].value : '';
			this.synchronizeProductsShow = true;
		},
		synchronizeProducts() {
			//同步商品
			if (this.synchronizeProductsCheck == '') {
				this.$message.warning('请选择店铺！')
				return
			}
			if (this.synchronizeProductsStatus == 2 && this.synchronizeProductsSKC == '') {
				this.$message.warning('请输入SKCID！')
				return
			}
			let data = {}
			if (this.synchronizeProductsStatus == 1) {
				data = {
					shopId: this.synchronizeProductsCheck,
					userId: this.userId,
				}
			} else {
				let lines = this.synchronizeProductsSKC.split(/\r?\n/);
				data = {
					shopId: this.synchronizeProductsCheck,
					userId: this.userId,
					skcList: lines
				}
			}
			const loading = this.$loading({
				lock: true,
				text: '同步中',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.tongBuShopee(data).then(res => {
				loading.close();
				if (res.code === 200) {
					this.$message.success(this.$t('other.a2405'))
					this.synchronizeProductsShow = false;
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				loading.close();
			})
		},
		synchronizeOrderProcessingProgress(){
			let arr = []
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}
			console.log(this.multipleSelection)
			for(let i =0;i<this.multipleSelection.length;i++){
				arr.push(this.multipleSelection[i].orderId)
			}
			const loading = this.$loading({
				lock: true,
				text: '同步中',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			orders.getOutboundTime(arr).then(res => {
				loading.close();
				if (res.code === 200) {
					this.$message.success(this.$t('other.a2405'))
					this.refleshPage();
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				loading.close();
			})
		},
		Synchronize(num) {
			let start_time = ''
			let end_time = ''
			if (num === 0) {
				start_time = utils.getRecentDays(-3);
				end_time = utils.getRecentDays(0);
			} else if (num === 1) {
				start_time = utils.getRecentDays(-7);
				end_time = utils.getRecentDays(0);
			} else if (num === 2) {
				start_time = utils.getRecentDays(-30);
				end_time = utils.getRecentDays(0);
			}
			const arr = {
				end: end_time,
				start: start_time,
				shopIds: JSON.parse(localStorage.getItem('userInfo')).shopIds,
				userId: this.userId
			}
			console.log(arr)
			console.log(this.idShop)
			this.$message.warning(this.$t('other.a798'))
			setTimeout(() => {
				this.updatShopAllOrders({
					payload: arr,
					text: this.$t('other.a1003')
				})
			}, 1000)


		},


		setFlags(val) {//发送设置旗帜的请求，同时将页面的每个订单插上旗帜
			console.log(val)
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}

			let arr = this.mapList[0].get('all')
			arr.forEach(p => {
				this.multipleSelection.forEach(i => {
					if (p.orderId === i.orderId) {
						p.flagId = val.flagId
					}
				})
			})


			arr.forEach(p => {
				p.flagId = p.flagId == null ? 0 : p.flagId

			})
			console.log('arr', arr)



			//    this.orderClassification(arr,-1)



			let params = {
				flagId: val.flagId,
				orderIds: this.multipleSelection.map(p => { return p.orderId })
			}

			let list = [{
				color: val.colorId,
				describe: val.desc,
				isChoose: 1,
				userId: this.userId
			}]

			// this.updatFlagDesc(list)

			printApi
				.updataUserFlageDesc(list)
				.then(res => {
					if (res.code === 200) {
						console.log('更新旗帜描述', res.data)
						newOrdersApi
							.setOrderFlag(params)
							.then(res => {
								if (res.code === 200) {
									console.log('设置标记', res.data)
									this.$message.success(this.$t('other.a741'))
									this.multipleSelection.forEach(p => {
										p.checked = false
										p.flagColor = val.colorId
										p.flagDes = val.desc
										p.flagId = params.flagId
									})
									this.updateOrderInfo()
								} else {
									this.$message.warning(res.msg)
								}
							})
					} else {
						this.$message.warning(res.msg)
					}
				})

		},

		updatFlagDesc(params) {
			printApi
				.updataUserFlageDesc(params)
				.then(res => {
					if (res.code === 200) {
						console.log('更新旗帜描述', res.data)

					}
				})
		},

		conversion(key, index) {
			let ttp = null
			if (index == 0) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == 'DXS' ? this.$t('other.a1004') : key
				}
			} else if (index == 1) {
				ttp = key == 'all' ? this.$t('storePending').all : utils.shopeeAndLazada(key, true)
			} else if (index == 2) {
				ttp = key == 'all' ? this.$t('storePending').all : utils.MatchStoreNameAccorderStoreId(key)
			} else if (index == 3) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == 0 ? this.$t('storePending').notgenerated : key == 1 ? this.$t('storePending').loading : this.$t('storePending').Generated
				}

			} else if (index == 4) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == true ? this.$t('storePending').printed : this.$t('storePending').notprinted
				}

			} else if (index == 5) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key
				}

			} else if (index == 6) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == 99999 ? this.$t('other.a1005') : key == null || key == 0 ? this.$t('other.a1006') : key
				}

			} else if (index == 7) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key
				}

			} else if (index == 8) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == true ? this.$t('storePending').shipped : this.$t('storePending').tobeshipped
				}

			} else if (index == 9) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == true ? this.$t('storePending').yes : this.$t('storePending').notYet
				}

			} else if (index == 10) {
				if (key == 'all') {
					ttp = this.$t('storePending').all
				} else {
					ttp = key == true ? this.$t('storePending').singlesku : this.$t('storePending').multiplesku
				}

			} else {
				return key
			}


			return ttp
		},

		showFlageStyle(id) {
			console.log('id', id)
			let ttp = this.flashPage.find(item => item.flagId == id)
			if (ttp) {
				return ttp.style
			} else {
				return ''
			}
			console.log('ttp', ttp)
			// return ttp
		},
		//开始生成运单号
		startReadyOrders(num) {
			console.log(this.multipleSelection)
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}
			this.isNotify = true
			let list = this.multipleSelection.map(p => {
				return {
					orderId: p.orderId,
					shopId: p.shopId,
					type: num,
					userId: this.userId
				}
			})

			this.multipleSelection.forEach(p => {
				this.itemTargetList.push(p.orderId)
			})
			// this.getNewOrdersInfo(this.itemTargetList)

			newOrdersApi
				.sartReadyOrders(list)
				.then(res => {
					if (res.code === 200) {
						// 将要轮询的订单号暂存起来
						this.multipleSelection.forEach(p => {
							this.itemTargetList.push(p.orderId)
						})


						this.getNewOrdersInfo(this.itemTargetList)

					} else {
						this.$message.warning(res.msg)
					}
				})

			console.log('list', list)
		},

		//轮询运单号是否生成
		getNewOrdersInfo(list) {
			newOrdersApi
				.getNewOrders(list)
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						res.data.forEach(p => {
							if (p.trackingNo) {
								if (this.multipleSelection.length < this.successTotal) {
									this.successTotal++
								}
								let indexNum = this.itemTargetList.findIndex(item => item == p.orderId)
								console.log(indexNum)
								this.itemTargetList.splice(indexNum, 1)

							}
						})

						console.log(this.itemTargetList)

						setTimeout(() => {
							if (this.itemTargetList.length) {

								this.getNewOrdersInfo(this.itemTargetList)
							} else {
								this.$message.success(this.$t('other.a1007'))
								this.isNotify = false
								setTimeout(() => {
									this.init()
									this.getNotHandlePages()


								}, 800)
							}

						}, 1000)


					} else {
						this.$message.warning(res.msg)
					}
				})
		},



		mergerPrintPicklist() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}

			utils.cleanStorageData()
			let list = this.multipleSelection.map(p => {
				return p.orderId
			})


			localStorage.setItem('picklistInfoCopy', JSON.stringify(list))

			const { href } = this.$router.resolve({
				name: 'productPicklist',

			})
			window.open(href)

		},




		gotoprint(item) {
			console.log(item)
			item.hasPrined = true
			if (item.platform == 'SHOPEE') {
				item.urlCopy.forEach(p => {
					window.open(p)
				})
			}

			if (item.platform == 'LAZADA') {

				let Base64 = require('js-base64').Base64
				let file = item.urlCopy.data.document.file

				let newfile = Base64.decode(file)
				localStorage.removeItem('alipay')
				localStorage.setItem('html', newfile)
				let newUrl = location.host + '/sealpage'
				console.log(newUrl)
				window.open('http://' + newUrl)

			}

			this.addPrintNum(item.orders)

		},
		printPicklist(item) {
			console.log(item)
			let list = item.orders

			localStorage.setItem('picklistInfoCopy', JSON.stringify(list))

			const { href } = this.$router.resolve({
				name: 'productPicklist',

			})
			window.open(href)


		},

		kvjmfh(id) {
			let desc = ''
			if (id && id.initType == 0) {
				desc = 'Drop off'
			} else if (id && id.initType == 1) {
				desc = 'Pick up'
			}

			return desc
		},

		addPrintNum(list) {
			newOrdersApi
				.addPrintNum(list)
				.then(res => {
					if (res.code === 200) {
						console.log('增加了打印次数！')
					} else {
						console.log('增加了打印次数！', res.msg)
					}
				})

		},

		printDefaultOrder() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}
			let list = this.multipleSelection.map(p => { return p.orderId })
			newOrdersApi
				.getOrderBillUrl(list)
				.then(res => {
					if (res.code === 200) {
						console.log('面单地址', res.data)
						res.data.forEach(p => {
							p.hasPrined = false
							p.time = utils.renderTimeDate(p.createTime)
							p.orders = JSON.parse(p.ordersn)
							p.urlCopy = JSON.parse(p.url)
							p.name = p.logistics + "_" + p.time + "_" + p.orders.length
						})
						this.printedUrl = res.data
						this.printedvisabable = true
					} else {
						this.message.warning(res.msg)
					}
				})
		},
		printFastOrder() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}

			let arr = this.multipleSelection.map((p, index) => {
				return p.orderId
			})
			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))



			let routeData2 = this.$router.resolve({
				name: "productAndPicklist",
			})
			window.open(routeData2.href, '_blank');

			// this.addPrintNum(arr)
			this.$confirm(this.$t('other.a1009'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a1010'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			}).then(() => {
				this.refleshPage()
			})


		},
		printFastOrderSH() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}

			let arr = this.multipleSelection.map((p, index) => {
				return p.orderId
			})
			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))



			let routeData2 = this.$router.resolve({
				name: "productExpressSheet",
			})
			window.open(routeData2.href, '_blank');

			// this.addPrintNum(arr)
			this.$confirm(this.$t('other.a1009'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a1010'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			}).then(() => {
				this.refleshPage()
			})


		},
		printFastOrderLA() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a1008'))
				return
			}

			let arr = this.multipleSelection.map((p, index) => {
				return p.orderId
			})
			localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))



			let routeData2 = this.$router.resolve({
				name: "productLazada",
			})
			window.open(routeData2.href, '_blank');

			// this.addPrintNum(arr)
			this.$confirm(this.$t('other.a1009'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a1010'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			}).then(() => {
				this.refleshPage()
			})


		},

		goStockList() {
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}
			utils.cleanStorageData()
			let list = this.multipleSelection.map(p => {
				return p.orderId
			})


			localStorage.setItem('stockingInfoCopy', JSON.stringify(list))

			let routeData2 = this.$router.resolve({
				name: "productStockling",
				query: {
					flag: this.activeIndex[0]
				}
			})
			window.open(routeData2.href, '_blank');
		},

		handleBtn(key, index, indexTwo) {
			this.activeBtnIndex = [key, index, indexTwo]
			console.log(key, index, indexTwo)
			let list = JSON.parse(JSON.stringify(this.activeIndex))
			list[index] = indexTwo
			this.activeIndex = []
			for (let i = 0; i < list.length; i++) {
				if (i > index) {
					list[i] = 0
				}
				this.activeIndex.push(list[i])
			}


			let orderlist = this.mapList[index].get(key)

			// if(orderlist[0].platform == 'SHOPEE'){
			// 	this.showFastBtn=true
			// }else{
			// 	this.showFastBtn=false
			// }
			// this.totalList=orderlist.length
			this.orderClassification(orderlist, index)
			console.log('orderlist', orderlist)


		},

		init() {
			this.multipleSelection = []
			this.hasData = false
			this.activeIndex[0] = 0
			this.getDataParams.end = null
			this.getDataParams.start = null
			this.getDataParams.hasStoreItem = true
			this.getDataParams.hasPdf = true
			this.getDataParams.offset = null
			this.getDataParams.page = 0
			this.getDataParams.orderId = null
			this.getDataParams.platform = null
			this.getDataParams.sellerUserId = null
			this.getDataParams.shopIds = this.allshopIds
			this.getDataParams.storeIds = this.allstoreIds
			this.getDataParams.sortType = 0
			this.getDataParams.userId = this.userId
			this.activeBtnIndex = []
			this.mapList = []
			this.successTotal = 0
		},

		updateOrderInfo() {
			this.showLoading()
			newOrdersApi
				.queryPendingOrders(this.getDataParams)
				.then(res => {
					if (res.code === 200) {
						this.hasData = true
						res.data.forEach(p => {
							p.flagId = p.msgToStore ? 99999 : p.flagId
							p.timeList = []
							p.items.length > 1 ? p.onesku = false : p.onesku = true
							p.loadingType = p.sent ? p.ready ? 2 : 1 : 0
							p.items.printNum == 0 ? p.printed = false : p.printed = true
							p.shipByDate = utils.renderTimeDate(p.shipByDate)
							p.flagId = p.flagId == null ? 0 : p.flagId
							p.auditTime = p.auditTime == null ? p.auditTime : utils.renderTime(p.auditTime)
							p.createTime = p.createTime == null ? p.createTime : utils.renderTime(p.createTime)
							p.packagedTime = p.packagedTime == null ? p.packagedTime : utils.renderTime(p.packagedTime)
							p.printTime = p.printTime == null ? p.printTime : utils.renderTime(p.printTime)
							p.payTime = p.payTime == null ? p.payTime : utils.renderTime(p.payTime)
							p.printed = p.printNum == 0 && p.printTime == null ? false : true
							p.itemNum = p.items.length
							p.itemAmount = 0
							p.items.forEach(k => {
								p.itemAmount += k.variationQuantityPurchased
							})
							p.timeList.push(p.auditTime ? this.$t('other.a962') : null)
							if (p.printTime) {
								p.timeList.push(p.printTime ? this.$t('other.a960') : null)
							}
							if (p.checkTime) {
								p.timeList.push(p.checkTime ? this.$t('other.a959') : null)
							}

							if (p.packagedTime) {
								p.timeList.push(p.packagedTime ? this.$t('other.a958') : null)
							}
						})

						this.orderClassification(res.data, -1)

					} else {
						this.$message.warning(res.msg)
					}
				})
		},



		//获取待处理的订单数据
		getNotHandlePages() {
			newOrdersApi
				.queryPendingOrders(this.getDataParams)
				.then(res => {
					console.log(res.code)
					if (res.code === 200) {
						this.hasData = true
						res.data.forEach(p => {
							p.flagId = p.msgToStore ? 99999 : p.flagId
							p.timeList = []
							p.items.length > 1 ? p.onesku = false : p.onesku = true
							p.loadingType = p.sent ? p.ready ? 2 : 1 : 0
							p.items.printNum == 0 ? p.printed = false : p.printed = true
							p.shipByDate = utils.renderTimeDate(p.shipByDate)
							p.flagId = p.flagId == null ? 0 : p.flagId
							p.auditTime = p.auditTime == null ? p.auditTime : utils.renderTime(p.auditTime)
							p.createTime = p.createTime == null ? p.createTime : utils.renderTime(p.createTime)
							p.packagedTime = p.packagedTime == null ? p.packagedTime : utils.renderTime(p.packagedTime)
							p.printTime = p.printTime == null ? p.printTime : utils.renderTime(p.printTime)
							p.payTime = p.payTime == null ? p.payTime : utils.renderTime(p.payTime)
							p.printed = p.printNum == 0 && p.printTime == null ? false : true
							p.itemNum = p.items.length
							p.itemAmount = 0
							p.items.forEach(k => {
								p.itemAmount += k.variationQuantityPurchased
							})
							p.timeList.push(p.auditTime ? this.$t('other.a962') : null)
							if (p.printTime) {
								p.timeList.push(p.printTime ? this.$t('other.a960') : null)
							}
							if (p.checkTime) {
								p.timeList.push(p.checkTime ? this.$t('other.a959') : null)
							}

							if (p.packagedTime) {
								p.timeList.push(p.packagedTime ? this.$t('other.a958') : null)
							}

						})


						res.data.sort((a, b) => {
							return new Date(b.auditTime) - new Date(a.auditTime)
						})

						for (let i = 0; i < 11; i++) {
							this.activeIndex.push(0)
							this.mapList.push(new Map())
							this.mapList[i].set('all', res.data)
							if (i == 4 || i == 8 || i == 9 || i == 10) {
								this.mapList[i].set(true, [])
								this.mapList[i].set(false, [])
							}
						}

						this.mapList[0].set('SHOPEE', [])
						this.mapList[0].set('LAZADA', [])
						let listMap = new Map()

						res.data.forEach(p => {
							listMap.set(p.platform, this.getMap(this.mapList[0], p.platform, p))
						})
						console.log('listmap', listMap)
						console.log('获取待处理的订单', res.data);
						// this.getUserAddress();
						this.totalList = res.data.length
						this.orderClassification(res.data, -1)
						this.orderClassification(listMap.get('SHOPEE'), 0)

					} else {
						this.$message.warning(res.msg)
					}
				})
		},

		//将获取到待单进行分类
		orderClassification(list, num) {
			let orderlist = JSON.parse(JSON.stringify(list))
			this.btnlist = []

			this.mapList.forEach((key, i) => {
				if (i > num) {
					for (let [ky] of key) {
						key.set(ky, [])
					}
				}

			})

			orderlist.forEach((p, index) => {
				if (num < 0) {
					this.mapList[0].set(p.platform, this.getMap(this.mapList[0], p.platform, p))
				}
				if (num < 1) {
					this.mapList[1].set(p.shopId, this.getMap(this.mapList[1], p.shopId, p))
				}
				if (num < 2) {
					this.mapList[2].set(p.storeId, this.getMap(this.mapList[2], p.storeId, p))
				}
				// 加载状态 0：未生成 1：加载中 2：已加载 
				if (num < 3) {
					let list = this.mapList[3].get(p.loadingType)
					if (list == null || list == undefined) {
						list = []
					}
					list.push(p)
					this.mapList[3].set(p.loadingType, list)
				}
				if (num < 4) {
					this.mapList[4].set(p.printed, this.getMap(this.mapList[4], p.printed, p))
				}
				if (num < 5) {
					this.mapList[5].set(p.logistics, this.getMap(this.mapList[5], p.logistics, p))
				}
				if (num < 6) {
					this.mapList[6].set(p.flagId, this.getMap(this.mapList[6], p.flagId, p))
				}
				if (num < 7) {
					this.mapList[7].set(p.shipByDate, this.getMap(this.mapList[7], p.shipByDate, p))
				}
				if (num < 8) {
					this.mapList[8].set(p.sent, this.getMap(this.mapList[8], p.sent, p))
				}
				if (num < 9) {
					this.mapList[9].set(p.packaged, this.getMap(this.mapList[9], p.packaged, p))
				}
				if (num < 10) {
					this.mapList[10].set(p.onesku, this.getMap(this.mapList[10], p.onesku, p))
				}
			})

			for (let i = 0; i < 11; i++) {
				if (i > num) {
					this.mapList[i].set('all', list)
				}
			}
			const title = {

				0: this.$t('storePending').Form,
				1: this.$t('storePending').shoptype,
				2: this.$t('storePending').Warehouse_type,
				3: this.$t('storePending').Loading_status,
				4: this.$t('storePending').Printstatus,
				5: this.$t('storePending').LogisticsType,
				6: this.$t('storePending').orderMakr,
				7: this.$t('storePending').lastDeliveryTime,
				8: this.$t('storePending').orderStatus,
				9: this.$t('storePending').exwarehouse,
				10: this.$t('storePending').orderInclude,
			}


			this.mapList.forEach((key, i) => {
				let list = []
				key.forEach((item, value) => {
					list.push({
						key: value,
						value: item
					})
				})
				this.btnlist.push({
					desc: title[i],
					option: list
				})
			})


			if (this.activeIndex[9] == 0) {
				this.target = 'all'
			}
			if (this.activeIndex[9] == 1) {
				this.target = true
			}
			if (this.activeIndex[9] == 2) {
				this.target = false
			}

			this.btnlist.forEach((p, index) => {
				if (index == 7) {
					p.option.forEach(k => {
						let ttp = new Date(k.key)
						k.num = ttp.valueOf()
					})
				}
			})

			this.btnlist[7].option.sort((a, b) => {
				return a.num - b.num
			})

			this.btnlist[0].option.splice(0, 1)



			console.log('btnlist', this.btnlist)
			console.log('activeIndex', this.activeIndex)
			console.log('mapList', this.mapList)
		},

		getMap(mapList, key, p) {
			let list = mapList.get(key)
			if (list == null || list == undefined) {
				list = []
			}
			list.push(p)
			return list

		},


		getTime(time) {
			return utils.renderTime(time)
		},

		handleSelectionChange(val) {
			this.multipleSelection = val;
			console.log('multipleSelection', this.multipleSelection)
		},

		//控制每页显示订单条数
		handleSizeChange(val) {
			console.log(`${val}`);
			this.offset = parseInt(`${val}`)
		},
		//显示当前第几页
		handleCurrentChange(val) {
			console.log(`${val}`)
			if (`${val}` == 'undefined') {
				this.currentPage = 1
				this.page = 1
			} else {
				this.currentPage = parseInt(`${val}`)
				this.page = parseInt(`${val}`)
			}
		},







	}
}
</script>

<style lang="scss" scoped>
.not_handle {
	position: relative;

	.nonjb {
		background-color: #eee;
		box-sizing: border-box;
		padding: 5px 10px;
		min-height: 200px;

		.pjhvh {
			height: 30px;
			border-left: 1px solid #d9d9d9;
		}

		.pjhvh:nth-last-child(1) {
			height: 30px;
			border-left: none;
		}
	}


	.pjhvh::before {
		content: '';
		border: 3px solid #f3f3f3;
		background-color: #d9d9d9;
		display: inline-block;
		width: 5px;
		height: 5px;
		border-radius: 5px;
		margin-left: -6px;
		margin-right: 10px;

	}

	.title {
		font-size: 18px;
		margin-bottom: 10px;
		text-align: center;

	}

	/deep/ .el-dialog__body {
		padding: 10px 10px;
	}

	/deep/ .el-step__title {
		color: #000;
		font-weight: bold;
	}

	/deep/ .el-step__description {
		color: #000;
	}

	.step {
		width: 100%;
		box-sizing: border-box;
		padding: 0 15px;
	}

	.notify-boxw {
		width: 330px;
		height: 80px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		position: fixed;
		top: 150px;
		right: 30px;
		border-radius: 8px;
		box-sizing: border-box;
		padding: 10px;
		z-index: 999999;
		background: #ffff;
	}

	.el-icon-loading:before {
		content: "\E6CF";
		font-size: 20px;
	}


	.search_wraper {
		display: flex;
		margin: 20px 0;

		.search_item {
			display: flex;
			margin-right: 20px;
			align-items: center;

			.item_desc {
				display: inline-block;
				width: 120px;
			}
		}

	}

	.checkallbox {
		cursor: pointer;
		padding-bottom: 20px;
	}

	.operation_area {
		display: flex;

		.opeartion_btn {
			margin-right: 10px;
		}

	}

	.Pager {
		position: fixed;
		bottom: 0;
		width: 100%;
		height: 45px;
		background-color: #FFFFFF;
		z-index: 99;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		box-sizing: border-box;
		padding-right: 220px;
	}

	.btn_box {
		font-size: 14px;
		margin-top: 15px;

		.btn_item {
			display: inline-block;
			box-sizing: border-box;
			padding: 4px 8px;
			border: 1px solid #d9d9d9;
			margin-right: 5px;
			cursor: pointer;



		}

		.btn_desc {
			margin-right: 15px;
			min-width: 65px;
		}

		.btn_item_active {
			background-color: #1890ff;
			color: #fff;
		}

		.btn_outer {
			padding: 5px 0 10px 0;

		}
	}

	.order_box {
		margin: 0 15px 60px 0;


		.order_time {
			font-size: 10px;
		}


		.content_wrapper {
			display: flex;
			color: #FFFFFF;
			align-items: center;

			.content_pic {
				display: inline-block;
				width: 80px;
				height: 80px;
				overflow: hidden;
			}
		}

		.ordersn-box {
			font-size: 12px;

		}

		.tooldesc {
			width: 100%;
			text-overflow: ellipsis;
			cursor: pointer;
		}


		.el-icon-edit {
			font-size: 14px;
			color: #409EFF;
			cursor: pointer;
		}



		.pic_wrapper {
			display: inline-block;
			width: 50px;
			height: 50px;
			overflow: hidden;
			position: relative;
			margin: 0.5px;
			border: 1px solid #eee;
		}

		.pic-wrapper-quantity {
			position: absolute;
			top: 0;
			right: 0;
			display: inline-block;
			min-width: 15px;
			min-height: 15px;
			line-height: 15px;
			background-color: red;
			font-size: 8px;
			color: #fff;
			text-align: center;
		}


	}
}
</style>
